import { forwardRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import Treemap from 'highcharts/modules/treemap';
import Heatmap from 'highcharts/modules/heatmap';
import Accessibility from 'highcharts/modules/accessibility';
import Treegraph from 'highcharts/modules/treegraph';
import { mergeDeepRight } from 'ramda';
import styled, { css } from 'styled-components';

Exporting(Highcharts);
Treemap(Highcharts);
Treegraph(Highcharts);
Heatmap(Highcharts);
Accessibility(Highcharts);

export const ChartContainer = styled.div<{ allowChartContainerOverflow?: boolean }>`
  max-width: 100%;
  width: 100%;

  div:first-child {
    ${({ allowChartContainerOverflow }) =>
      allowChartContainerOverflow &&
      css`
        overflow-x: auto !important;
      `}
  }
`;

Highcharts.setOptions({
  accessibility: {
    enabled: false,
  },
  colors: ['#41B5E9', '#FA8832', '#34393C', '#E46151'],
  chart: {
    style: {
      color: '#333',
      fontFamily: '"Poppins", sans-serif',
    },
  },
  legend: {
    align: 'right',
    verticalAlign: 'bottom',
  },
  xAxis: {
    gridLineWidth: 1,
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
  yAxis: {
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
});

export const BaseChart = forwardRef<
  HighchartsReact.RefObject,
  {
    options: Highcharts.Options;
    allowChartContainerOverflow?: boolean;
  }
>(({ options, allowChartContainerOverflow = false }, ref) => {
  const combinedOptions = mergeDeepRight<Highcharts.Options, Highcharts.Options>(
    {
      title: {
        text: null,
      },

      chart: {
        events: {
          render() {
            // this event makes sure that teh chart fits its container after the data is loaded
            window.dispatchEvent(new Event('resize'));
          },
        },
      },

      credits: {
        enabled: false,
      },

      exporting: {
        enabled: true,
        width: 1600,
      },

      legend: {
        enabled: true,
      },
    },
    options,
  );

  return (
    <ChartContainer allowChartContainerOverflow={allowChartContainerOverflow}>
      <HighchartsReact ref={ref} highcharts={Highcharts} options={combinedOptions} />
    </ChartContainer>
  );
});

BaseChart.displayName = 'BaseChart';
